<template lang="pug">
  .crud
    modal-quotations-action-prop(:id="currentId" :action="currentAction" :sold="sold")
    modal-send-email(:id="currentId" model="quotations" :emails="emails" :quotationProducts="quotationProducts")
    modal-quotations-prop(:id="currentId")
    modal-quotations-loss(:id="currentId")
    modal-quotations-set-order(:id="currentId")
    modal-quotations-supplier(:id="currentId" :quotation="quotation")
    modal-import(model="quotations" :title="$t('front.import_modal', {model: $t('strings.quotations')})")
    modal-see-loss-reason(:quotation="quotation")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.quotations') }}:
            span {{ $t('strings.description', {attribute: $t('strings.quotations')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addQuotation") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuotationsConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  //-
                    vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                      vm-icon(icon="upload-outline")
                      slot &nbsp;{{ $t('strings.import') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="quotations")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                div
                  vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px")
                    div(v-for="(item,index) in columns")
                      vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('quotations.'+ item) + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('quotations.'+ item) + ', desc'")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")
                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('quotations.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                        vm-select.filter(url="users" column="name" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('quotations.created_by_id')" v-model="filters.whereIn.created_by_id" @input-change="autoCompleteFunc")
                          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in users")
                        vm-select.filter(url="customers" column="tradename" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('quotations.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                          vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in quotationsCatalog.customers")

                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations.' + column) }}
              vm-th &nbsp;  &nbsp; &nbsp;
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  .details(@click="editQuotation(data[indextr])")
                    slot(v-if="column == 'total_mn' || column == 'unit_price' || column == 'total'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status' && column != 'total_mn' && column != 'total' && column != 'unit_price' && column != 'customer_id' && column != 'created_by_id' && column != 'created_at' && column != 'currency_id' && column != 'email_sent'") {{data[indextr][column] | truncate }}
                    vm-icon(v-if="column == 'email_sent'" color="primary" :icon="data[indextr]['email_sent'] ? 'email-outline' : ''")
                    vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr][column])") {{data[indextr]['status_display']}}
                    slot(v-if="column == 'created_by_id'") {{data[indextr]['created_by'] ? data[indextr]['created_by']['name'] : ''}}
                    slot(v-if="column == 'customer_id'") {{data[indextr]['customer']['tradename']}}
                    slot(v-if="column == 'currency_id'") {{data[indextr]['currency']['code']}}
                    slot(v-if="column == 'created_at'") {{data[indextr]['created_at'] | moment('DD-MMMM-YYYY')}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="editQuotation(data[indextr], tr)")
                        vm-icon(icon="edit-2-outline")
                        slot &nbsp;{{ $t('strings.edit') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '1'" @click="deleteQuotationConfirm(data[indextr])")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '1'" @click="setPurchaseOrder(data[indextr])")
                        vm-icon(icon="checkmark-circle-outline")
                        slot &nbsp;{{ $t('strings.accept') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '1'" @click="setActionQuotation(data[indextr], 'cancelled')")
                        vm-icon(icon="close-circle-outline")
                        slot &nbsp;{{ $t('strings.cancel') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '1'" @click="setLossQuotation(data[indextr])")
                        vm-icon(icon="alert-circle-outline")
                        slot &nbsp;{{ $t('strings.loss') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '3' || data[indextr]['status'] == '4'" @click="setActionQuotation(data[indextr], 'pending')")
                        vm-icon(icon="alert-circle-outline")
                        slot &nbsp;{{ $t('strings.pending') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != '1'" @click="editQuotation(data[indextr])")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.view') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '4'" @click="seeLossReason(data[indextr])")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.see_loss_reason') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="addQuotationsSupplier(data[indextr])")
                        vm-icon(icon="book-outline")
                        slot &nbsp;{{ $t('strings.supplier_quotations') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="printRecord(data[indextr])")
                        vm-icon(icon="printer-outline")
                        slot &nbsp;{{ $t('strings.print') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="sendEmail(data[indextr])")
                        vm-icon(icon="email-outline")
                        slot &nbsp;{{ $t('strings.email') }}
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import ModalImport from '@/components/modals/ModalImport.vue'
import ModalSendEmail from '@/components/modals/ModalSendEmail.vue'
import ModalQuotationsActionProp from '@/components/modals/ModalQuotationsActionProp.vue'
import ModalQuotationsProp from '@/components/modals/ModalQuotationsProp.vue'
import ModalQuotationsLoss from '@/components/modals/ModalQuotationsLoss.vue'
import ModalQuotationsSetOrder from '@/components/modals/ModalQuotationsSetOrder.vue'
import ModalQuotationsSupplier from '@/components/modals/ModalQuotationsSupplier.vue'
import ModalSeeLossReason from '@/components/modals/ModalSeeLossReason.vue'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'Quotations',
  components: {
    ModalImport,
    ModalSendEmail,
    ModalQuotationsActionProp,
    ModalQuotationsProp,
    ModalQuotationsLoss,
    ModalQuotationsSetOrder,
    ModalQuotationsSupplier,
    ModalSeeLossReason
  },
  data: () => ({
    currentPage: 1,
    currentAction: '',
    currentId: 1,
    sold: false,
    selected: [],
    enabledDelete: false,
    emails: [],
    quotationProducts: [],
    quotation: {},
    columns: [
      'folio',
      'customer_id',
      'order_customer',
      'created_by_id',
      'total_mn',
      'total',
      'currency_id',
      'created_at',
      'email_sent',
      'status'
    ],
    status: [
      {
        text: 'Pendiente',
        value: 1,
        color: 'primary'
      },
      {
        text: 'Vendido',
        value: 2,
        color: 'success'
      },
      {
        text: 'Cancelado',
        value: 3,
        color: 'danger'
      },
      {
        text: 'Perdida',
        value: 4,
        color: 'warning'
      }
    ],
    filters: {
      where: {
        folio: '',
        customer: {
          tradename: ''
        },
        order_customer: '',
        param: ''
      },
      whereIn: {
        created_by_id: [],
        customer_id: [],
        status: []
      },
      whereBetween: {
        total: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters([
      'quotations',
      'quotationsCatalog',
      'pagination',
      'filterParams',
      'users'
    ]),
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total_mn), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getQuotations(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getQuotations(this.currentPage)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    this.currentPage = this.pagination.currentPage ? this.pagination.currentPage : 1
    await this.getQuotations(this.currentPage)
    this.getCatalog()
    await this.loadUsers()
  },
  methods: {
    ...mapActions([
      'deleteQuotation',
      'deleteQuotations',
      'loadQuotations',
      'loadCatalog',
      'loadUsers',
      'actionQuotation',
      'setModalImportVisible',
      'setModalSendEmail',
      'setModalActionPropVisible',
      'setModalPropVisible',
      'setModalLossVisible',
      'setModalPurchaseOrderVisible',
      'setModalQuotationsSupplierVisible',
      'setModalLossReasonVisible',
      'printReport',
      'applyFilter',
      'clearFilter',
      'loadQuotationProductsAttachments'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    addQuotation () {
      this.$router.push({ name: 'newQuotation', params: { isAdd: true } })
    },
    editQuotation (quotation) {
      let id = quotation.id
      this.$router.push({ name: 'editQuotation', params: { id: id } })
    },
    async deleteQuotationConfirm (quotation) {
      let t = this
      this.auxDeleteQuotation = () => {
        t.deleteQuotation(quotation).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quotation'), attribute: this.$t(quotation.folio) }),
        accept: this.auxDeleteQuotation
      })
    },
    async deleteQuotationsConfirm () {
      let t = this
      let quotationsMany = parseDeleteMany(this.selected, 'folio')
      this.auxDeleteQuotation = () => {
        t.deleteQuotations(quotationsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quotation'), attribute: quotationsMany.values }),
        accept: this.auxDeleteQuotation
      })
    },
    async setActionQuotation (record, action) {
      let t = this
      this.auxActionQuotation = () => {
        t.actionQuotation({ id: record.id, action })
      }
      this.$vm.dialog({
        color: 'warning',
        title: this.$t('strings.quotation'),
        text: this.$t('front.action_confirmation', { model: this.$t('strings.quotation'), action: this.$t('quotations.action_' + action) }),
        accept: this.auxActionQuotation
      })
    },
    setPurchaseOrder (record) {
      if (record['supplier_quotations'].length > 0) {
        this.currentId = record.id
        this.sold = false
        this.setModalPurchaseOrderVisible(true)
      } else {
        this.$vm.dialog({
          color: 'warning',
          title: this.$t('strings.quotation'),
          text: 'Es requerido subir al menos una cotizacion de proveedor'
        })
      }
    },
    setActionQuotationProp (record, action) {
      this.currentId = record.id
      this.currentAction = action
      this.sold = false
      this.setModalActionPropVisible(true)
    },
    setActionQuotationPropSold (record, action) {
      if (record.order_customer === null) {
        this.currentId = record.id
        this.currentAction = action
        this.sold = true
        this.setModalActionPropVisible(true)
      } else if (record.order_customer != null) {
        this.setActionQuotation(record, 'sold')
      }
    },
    setLossQuotation (record) {
      this.currentId = record.id
      this.setModalLossVisible(true)
    },
    addQuotationsSupplier (record) {
      if (record.general_supplier) {
        this.$vm.dialog({
          color: 'danger',
          title: this.$t('front.general_supplier_modal'),
          text: this.$t('front.general_supplier_confirmation', { attribute: this.$t(record.folio) })
        })
      } else {
        this.currentId = record.id
        this.quotation = record
        this.setModalQuotationsSupplierVisible(true)
      }
    },
    async getQuotations (page) {
      this.loadQuotations({ page })
    },
    async getCatalog () {
      Object.keys(this.quotationsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    printRecord (record) {
      this.currentId = record.id
      this.setModalPropVisible(true)
    },
    async sendEmail (record) {
      await this.loadQuotationProductsAttachments(record.id)
      this.currentId = record.id
      this.emails = []
      this.emails.push(record.customer.email)
      record.customer_contact && this.emails.push(record.customer_contact.email)
      this.quotationProducts = this.quotationProductsAttachments
      this.setModalSendEmail(true)
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    seeLossReason (quotation, index) {
      this.setModalLossReasonVisible(true)
      this.quotation = { ...quotation }
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
